<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M59.795 29.43L7.329 2.979C4.691 1.802 1.76 4.153 2.932 6.798l6.925 18.609c.25.67.838 1.157 1.544 1.275l32.273 5.394L11.4 37.47c-.706.118-1.295.604-1.544 1.275L2.932 57.353c-.879 2.645 1.76 4.997 4.397 3.527l52.466-26.453c2.051-.882 2.051-3.82 0-4.996z" transform="translate(-930 -271) translate(930 271)"/>
            </g>
        </g>
    </g>
</svg>
